import React from 'react';
import {
    Checkbox, InputLabel, FormControl, FormHelperText
} from '@deere/fuel-react';
import {Controller} from "react-hook-form";
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { getOptionSelected } from './utils/autocompleteUtils';

const icon = <CheckBoxOutlineBlankIcon fontSize="small"/>;
const checkedIcon = <CheckBoxIcon fontSize="small"/>;

export default function AutoCompleteCheckbox({ name, options, label, showLabel, limitTags, defValue="", disabled=false, onOptionsChange, control, required, isError=false, errorDesc="", backgroundColor=null}) {
    return (
        <FormControl fullWidth required={required} error={isError} disabled={disabled}>
            {showLabel && (<InputLabel htmlFor={name}>{label}</InputLabel>)}
            <Controller
                rules={{required: required}}
                control={control}
                defaultValue={defValue}
                value={defValue}
                name={name}
                render={({onChange, value}) => (
                    <Autocomplete
                        multiple
                        size="small"
                        disabled={disabled}
                        id={name}
                        limitTags={limitTags}
                        options={options}
                        disableCloseOnSelect
                        getOptionLabel={(option) => option.description}
                        getOptionSelected={getOptionSelected}
                        value={defValue}
                        onChange={(e, value) => {
                            onChange(value);
                            onOptionsChange(value);
                        }}
                        renderOption={(option, {selected}) => (
                            <React.Fragment>
                                <Checkbox
                                    icon={icon}
                                    checkedIcon={checkedIcon}
                                    style={{marginRight: 8}}
                                    checked={selected}
                                />
                                {option.description}
                            </React.Fragment>
                        )}
                        renderInput={(params) => (
                            <TextField {...params} variant="outlined" placeholder={`Select ${label}`} style={backgroundColor ? {backgroundColor: "white"} : {}}/>
                        )}
                    />
                )}
            />
            <FormHelperText>{isError && errorDesc}</FormHelperText>
        </FormControl>
    );
}